import { FilterOperator, useSearchSetPortalExamResultFilesQuery } from '@exam-center/graphql';
import { DataGrid } from '@shared/components';

import { ExamResultFileListNoRowsOverlay } from '../../components';
import { ORDER_TYPE } from '../../constants';
import { useExamResultFileListSearchParams } from '../../hooks';

import { columns } from './columns';

export default function ExamResultFileList() {
  const [
    { page, pageSize, sortBy, sortOrder, search, createdDateFrom, createdDateTo },
    { changePageNumber, changePageSize, changeSorting },
  ] = useExamResultFileListSearchParams();

  const { data, loading } = useSearchSetPortalExamResultFilesQuery({
    variables: {
      searchSetPortalExamResultFilesInput: {
        filter: {
          searchText: {
            fields: ['fileName'],
            value: search,
          },
          conditions: [
            {
              field: 'createdAt',
              operator: FilterOperator.Between,
              value: createdDateFrom && createdDateTo ? [createdDateFrom, createdDateTo] : null,
            },
          ].filter((condition) => condition.value !== null),
        },
        paging: {
          currentPage: page,
          pageSize,
        },
        order: {
          field: sortBy,
          type: ORDER_TYPE[sortOrder],
        },
      },
    },
  });

  const rows = data?.ecSearchSETPortalExamResultFiles.setPortalExamResultFiles ?? [];
  const total = data?.ecSearchSETPortalExamResultFiles.total ?? 0;

  return (
    <DataGrid
      columns={columns}
      rows={rows}
      loading={loading}
      disableRowSelectionOnClick
      rowHeight={48}
      disableColumnMenu
      hideFooter={total <= 0}
      sortingMode='server'
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        height: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
      slots={{
        noRowsOverlay: ExamResultFileListNoRowsOverlay,
      }}
      slotProps={{
        footer: {
          total,
          pagination: {
            page: page,
            count: total,
            rowsPerPage: pageSize,
            onPageChange: (_, page) => {
              changePageNumber(page);
            },
            onRowsPerPageChange: (event) => {
              changePageSize(parseInt(event.target.value));
            },
          },
        },
      }}
      onSortModelChange={(sorting) => {
        const sortModel = sorting[0];
        if (sortModel?.field && sortModel?.sort) {
          return changeSorting({
            sortOrder: sortModel.sort,
            sortBy: sortModel.field,
          });
        }

        return changeSorting({
          sortOrder: null,
          sortBy: null,
        });
      }}
    />
  );
}
